// extracted by mini-css-extract-plugin
export default {"wrapper":"Questions-module--wrapper--TnVY9"};